export enum ECustomFieldSubfieldDeleteButtonState {
  DELETE = 'delete',
  CONFIRM = 'confirm',
  CONFIRM_DISABLED = 'confirm_disabled',
}
